module.exports = __webpack_public_path__ + "static/media/cumhuriyet2023.39213a1a.mp4";